<template>
  <b-row class="font_Montserrat">
    <b-col cols="12">
      <div class="v2_font_size_18 font-weight-bold mt-3">
        Member Information
      </div>
      <div
        class="pl-3 v2_font_size_16 mt-3"
        v-for="key in availableMembershipKeys"
        :key="key"
      >
        <div class="font-weight-bold">{{ membershipKeysTitles[key] }}</div>
        <div v-for="(count, title) in kpiData[key]" :key="title">
          {{ getFormatTitle(title) }}:
          {{ count }}
        </div>
      </div>
    </b-col>
    <b-col cols="12" class="mt-3" v-if="kpiData.questionnaires">
      <div class="v2_font_size_18 font-weight-bold">Study Information</div>
      <div
        v-for="{ title, info } in kpiData.questionnaires"
        :key="title"
        class="pl-3 v2_font_size_16"
      >
        <div class="font-weight-bold mt-3">{{ title }}</div>
        <div
          v-if="
            typeof info.complete_studies !== 'undefined' &&
            info.complete_studies !== null
          "
        >
          Complete Studies: {{ info.complete_studies }}
        </div>
        <div
          v-if="
            typeof info.incomplete_studies !== 'undefined' &&
            info.incomplete_studies !== null
          "
        >
          Incomplete Studies: {{ info.incomplete_studies }}
        </div>
        <div
          v-if="
            typeof info.avg_time_for_completion !== 'undefined' &&
            info.avg_time_for_completion !== null
          "
        >
          Avg Time For Completion: {{ info.avg_time_for_completion }} minutes
        </div>
        <div
          v-if="
            typeof info.min_time_for_completion !== 'undefined' &&
            info.min_time_for_completion !== null
          "
        >
          Min Time For Completion: {{ info.min_time_for_completion }} minutes
        </div>
        <div
          v-if="
            typeof info.max_time_for_completion !== 'undefined' &&
            info.max_time_for_completion !== null
          "
        >
          Max Time For Completion: {{ info.max_time_for_completion }} minutes
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
const MEMBERSHIP_KEYS = {
  TOTAL: 'total_membership',
  REGISTERED: 'registered_membership',
};
export default {
  name: 'SocietyKpiReport',
  props: {
    kpiData: Object,
  },
  computed: {
    availableMembershipKeys: function () {
      return Object.values(MEMBERSHIP_KEYS).filter(
        (key) => !!this.kpiData[key]
      );
    },
    membershipKeysTitles: function () {
      return {
        [MEMBERSHIP_KEYS.TOTAL]: 'Total Membership',
        [MEMBERSHIP_KEYS.REGISTERED]: 'Registered Membership',
      };
    },
  },
  methods: {
    getFormatTitle: function (title) {
      return title !== 'Not specified' ? `${title}s` : 'Not specified';
    },
  },
};
</script>

<style scoped></style>
